const actions = {
  FINANCE_COMPANY_LIST_BEGIN: "FINANCE_COMPANY_LIST_BEGIN",
  FINANCE_COMPANY_LIST_SUCCESS: "FINANCE_COMPANY_LIST_SUCCESS",
  FINANCE_COMPANY_LIST_ERR: "FINANCE_COMPANY_LIST_ERR",
  FINANCE_COMPANY_LIST_RESET: "FINANCE_COMPANY_LIST_RESET",

  FINANCE_GENERATE_OTP_BEGIN: "FINANCE_GENERATE_OTP_BEGIN",
  FINANCE_GENERATE_OTP_SUCCESS: "FINANCE_GENERATE_OTP_SUCCESS",
  FINANCE_GENERATE_OTP_ERR: "FINANCE_GENERATE_OTP_ERR",
  FINANCE_GENERATE_OTP_RESET: "FINANCE_GENERATE_OTP_RESET",

  FINANCE_VERIFY_OTP_BEGIN: "FINANCE_VERIFY_OTP_BEGIN",
  FINANCE_VERIFY_OTP_SUCCESS: "FINANCE_VERIFY_OTP_SUCCESS",
  FINANCE_VERIFY_OTP_ERR: "FINANCE_VERIFY_OTP_ERR",
  FINANCE_VERIFY_OTP_RESET: "FINANCE_VERIFY_OTP_RESET",

  FINANCE_HISTORY_BEGIN: "FINANCE_HISTORY_BEGIN",
  FINANCE_HISTORY_SUCCESS: "FINANCE_HISTORY_SUCCESS",
  FINANCE_HISTORY_ERR: "FINANCE_HISTORY_ERR",
  FINANCE_HISTORY_RESET: "FINANCE_HISTORY_RESET",

  FINANCE_VIEW_DETAILS_BEGIN: "FINANCE_VIEW_DETAILS_BEGIN",
  FINANCE_VIEW_DETAILS_SUCCESS: "FINANCE_VIEW_DETAILS_SUCCESS",
  FINANCE_VIEW_DETAILS_ERR: "FINANCE_VIEW_DETAILS_ERR",
  FINANCE_VIEW_DETAILS_RESET: "FINANCE_VIEW_DETAILS_RESET",

  FINANCE_UPDATE_PROOF_DETAILS_BEGIN: "FINANCE_UPDATE_PROOF_DETAILS_BEGIN",
  FINANCE_UPDATE_PROOF_DETAILS_SUCCESS: "FINANCE_UPDATE_PROOF_DETAILS_SUCCESS",
  FINANCE_UPDATE_PROOF_DETAILS_ERR: "FINANCE_UPDATE_PROOF_DETAILS_ERR",
  FINANCE_UPDATE_PROOF_DETAILS_RESET: "FINANCE_UPDATE_PROOF_DETAILS_RESET",

  FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_BEGIN:
    "FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_BEGIN",
  FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_SUCCESS:
    "FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_SUCCESS",
  FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_ERR:
    "FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_ERR",
  FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_RESET:
    "FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_RESET",

  getFinanceCompanyListBegin: () => ({
    type: actions.FINANCE_COMPANY_LIST_BEGIN,
  }),

  getFinanceCompanyListSuccess: (data) => ({
    type: actions.FINANCE_COMPANY_LIST_SUCCESS,
    data,
  }),

  getFinanceCompanyListErr: (err) => ({
    type: actions.FINANCE_COMPANY_LIST_ERR,
    err,
  }),

  getFinanceCompanyListReset: () => ({
    type: actions.FINANCE_COMPANY_LIST_RESET,
  }),

  generateFinanceOtpBegin: () => ({
    type: actions.FINANCE_GENERATE_OTP_BEGIN,
  }),

  generateFinanceOtpSuccess: (data) => ({
    type: actions.FINANCE_GENERATE_OTP_SUCCESS,
    data,
  }),

  generateFinanceOtpErr: (err) => ({
    type: actions.FINANCE_GENERATE_OTP_ERR,
    err,
  }),

  generateFinanceOtpReset: () => ({
    type: actions.FINANCE_GENERATE_OTP_RESET,
  }),

  verifyFinanceOtpBegin: () => ({
    type: actions.FINANCE_VERIFY_OTP_BEGIN,
  }),

  verifyFinanceOtpSuccess: (data) => ({
    type: actions.FINANCE_VERIFY_OTP_SUCCESS,
    data,
  }),

  verifyFinanceOtpErr: (err) => ({
    type: actions.FINANCE_VERIFY_OTP_ERR,
    err,
  }),

  verifyFinanceOtpReset: () => ({
    type: actions.FINANCE_VERIFY_OTP_RESET,
  }),

  getFinanceHistoryBegin: () => ({
    type: actions.FINANCE_HISTORY_BEGIN,
  }),

  getFinanceHistorySuccess: (data) => ({
    type: actions.FINANCE_HISTORY_SUCCESS,
    data,
  }),

  getFinanceHistoryErr: (err) => ({
    type: actions.FINANCE_HISTORY_ERR,
    err,
  }),

  getFinanceHistoryReset: () => ({
    type: actions.FINANCE_HISTORY_RESET,
  }),

  getFinanceViewDetailsBegin: () => ({
    type: actions.FINANCE_VIEW_DETAILS_BEGIN,
  }),

  getFinanceViewDetailsSuccess: (data) => ({
    type: actions.FINANCE_VIEW_DETAILS_SUCCESS,
    data,
  }),

  getFinanceViewDetailsErr: (err) => ({
    type: actions.FINANCE_VIEW_DETAILS_ERR,
    err,
  }),

  getFinanceViewDetailsReset: () => ({
    type: actions.FINANCE_VIEW_DETAILS_RESET,
  }),

  updateFinanceProofDetailsBegin: () => ({
    type: actions.FINANCE_UPDATE_PROOF_DETAILS_BEGIN,
  }),

  updateFinanceProofDetailsSuccess: (data) => ({
    type: actions.FINANCE_UPDATE_PROOF_DETAILS_SUCCESS,
    data,
  }),

  updateFinanceProofDetailsErr: (err) => ({
    type: actions.FINANCE_UPDATE_PROOF_DETAILS_ERR,
    err,
  }),

  updateFinanceProofDetailsReset: () => ({
    type: actions.FINANCE_UPDATE_PROOF_DETAILS_RESET,
  }),

  updateFinanceProductProofDetailsBegin: () => ({
    type: actions.FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_BEGIN,
  }),

  updateFinanceProductProofDetailsSuccess: (data) => ({
    type: actions.FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_SUCCESS,
    data,
  }),

  updateFinanceProductProofDetailsErr: (err) => ({
    type: actions.FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_ERR,
    err,
  }),

  updateFinanceProductProofDetailsReset: () => ({
    type: actions.FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_RESET,
  }),
};

export default actions;
